import { render, staticRenderFns } from "./PerpetualLicenseInfo.vue?vue&type=template&id=75825911&scoped=true&"
import script from "./PerpetualLicenseInfo.vue?vue&type=script&lang=ts&"
export * from "./PerpetualLicenseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PerpetualLicenseInfo.vue?vue&type=style&index=0&id=75825911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75825911",
  null
  
)

export default component.exports